import { Database, Grid3x3, LineChart, Sigma } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";

const STATS_NAV_TOOLTIPS = {
  table: "Historique ✶ Tableau détaillé de vos parties jouées.",
  charts: "Graphiques ✶ Synthèse de vos performances récentes.",
  indicators: "Statistiques ✶ Indicateurs détaillés de vos parties.",
  matrix: "Matrice de maîtrise ✶ Vision globale ou par pool de niveau.",
};

export default function MenuStatsNav({
  screen = "table",
  onScreenChange = () => {},
  visible = true,
}) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer menuStatsNavContainer">
      <MenuIconTooltip
        tooltip={STATS_NAV_TOOLTIPS.table}
        placement="left"
        portal
        className={screen === "table" ? "filterIcon active" : "filterIcon"}
      >
        <Database
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("table")}
          aria-label="Historique des parties"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={STATS_NAV_TOOLTIPS.charts}
        placement="left"
        portal
        className={screen === "charts" ? "filterIcon active" : "filterIcon"}
      >
        <LineChart
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("charts")}
          aria-label="Graphiques de performance"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={STATS_NAV_TOOLTIPS.indicators}
        placement="left"
        portal
        className={screen === "indicators" ? "filterIcon active" : "filterIcon"}
      >
        <Sigma
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("indicators")}
          aria-label="Statistiques détaillées"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={STATS_NAV_TOOLTIPS.matrix}
        placement="left"
        portal
        className={screen === "matrix" ? "filterIcon active" : "filterIcon"}
      >
        <Grid3x3
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("matrix")}
          aria-label="Matrice de maîtrise"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
